import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';

const PlayerCardWrapper = props => {
    const { children, link, actionRequired, inactive, eventProfileV3, highlightCard, 'data-testid': dataTestId } = props;
    const conditionalLink = (content, href) => {
        if (href) {
            return (<Link to={href} data-testid={dataTestId && `${dataTestId}.link`}>{content}</Link>);
        }
        return (content);
    };
    return (
        <>
            {conditionalLink(
                <div className={`utr-card player-card ${actionRequired ? 'action-required' : ''} ${inactive ? 'inactive' : ''} ${eventProfileV3 ? 'player-card-v3' : ''} ${highlightCard ? 'highlight' : ''}`} data-test="card" data-testid={dataTestId || undefined}>
                    {children}
                </div>,
                link,
            )}

        </>
    );
};

PlayerCardWrapper.propTypes = {
    'data-testid': PropTypes.string,
};

PlayerCardWrapper.defaultProps = {
    'data-testid': null,
};

export default PlayerCardWrapper;
